import * as React from 'react'

import classNames from 'classnames/bind'
import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import FancyCheckbox from 'modules/core/components/Inputs/FancyCheckbox'

import styles from './index.module.scss'

const cx = classNames.bind(styles)
interface Props {
  label: string | JSX.Element
  readOnly?: boolean
  field: Field
  onChange?: React.MouseEventHandler
  color?: string
  size?: '200'
}

const LabeledFancyCheckbox = (props: Props) => {
  const { field, label, readOnly, onChange, color = 'grey800', size = '400' } = props

  const onClick: React.MouseEventHandler<HTMLLabelElement> = (event) => {
    if (readOnly) return

    if (onChange) {
      onChange(event)

      return
    }

    field.mapAndSet(!field.value)
  }

  return (
    <label
      onClick={onClick}
      className={cx(styles.label, color, {
        readOnly,
      })}
    >
      <div className={styles.checkbox}>
        <FancyCheckbox
          onClick={(event) => event.preventDefault()}
          disabled={readOnly}
          field={field}
        />
      </div>
      <span className={cx(styles.label, `size_${size}`)}>{label}</span>
    </label>
  )
}

export default observer(LabeledFancyCheckbox)
